<template>
  <div>
    <form @submit.prevent="onSubmit"
          @keydown="errors.clear($event.target.name)"
    >

      <div class="modal-form-block">
        <label for="company">
          {{ trans.get('dealers.company_label') }}
        </label>
        <input type="text"
               name="company"
               id="company"
               :placeholder="this.trans.get('dealers.company_placeholder')"
               v-model="dealer.company"
               required
        >
        <span class="alert alert-danger"
              v-if="errors.has('company')"
              v-text="errors.get('company')"
        >
        </span>
      </div>

      <div class="modal-form-block">
        <label for="address1">
          {{ trans.get('dealers.address1_label') }}
        </label>
        <input type="text"
               name="address1"
               id="address1"
               :placeholder="this.trans.get('dealers.address1_placeholder')"
               v-model="dealer.address1"
               required
        >
        <span class="alert alert-danger"
              v-if="errors.has('address1')"
              v-text="errors.get('address1')"
        >
        </span>
      </div>

      <div class="w-full flex justify-between">
        <div class="modal-form-block w-1/4">
          <label for="postcode">
            {{ trans.get('dealers.postcode_label') }}
          </label>
          <input type="text"
                 name="postcode"
                 id="postcode"
                 :placeholder="this.trans.get('dealers.postcode_placeholder')"
                 v-model="dealer.postcode"
                 required
          >
          <span class="alert alert-danger"
                v-if="errors.has('postcode')"
                v-text="errors.get('postcode')"
          >
          </span>
        </div>
        <div class="modal-form-block w-2/4">
          <label for="city">
            {{ trans.get('dealers.city_label') }}
          </label>
          <input type="text"
                 name="city"
                 id="city"
                 :placeholder="this.trans.get('dealers.city_placeholder')"
                 v-model="dealer.city"
                 required
          >
          <span class="alert alert-danger"
                v-if="errors.has('city')"
                v-text="errors.get('city')"
          >
          </span>
        </div>
        <div class="modal-form-block w-1/4">
          <label for="state">
            {{ trans.get('dealers.state_label') }}
          </label>
          <input type="text"
                 name="state"
                 id="state"
                 :placeholder="this.trans.get('dealers.state_placeholder')"
                 v-model="dealer.state"
                 required
          >
          <span class="alert alert-danger"
                v-if="errors.has('state')"
                v-text="errors.get('state')"
          >
          </span>
        </div>
      </div>
      <div class="modal-form-block">
        <label for="country">
          {{ trans.get('dealers.country_label') }}
        </label>
        <div class="relative w-full">
          <select name="country"
                  id="country"
                  v-model="dealer.country"
          >
            <option value="nocountry" class="capitalize">{{ trans.get('dealers.country_placeholder') }}</option>
            <option v-for="country in countries" :key="country.id"
                    :value="country.code"
            >
              {{ country.name }}
            </option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="modal-form-block">
        <label for="state">
          {{ trans.get('dealers.phone_label') }}
        </label>
        <input type="text"
               name="phone"
               id="phone"
               :placeholder="this.trans.get('dealers.phone_placeholder')"
               v-model="dealer.phone"
               required
        >
        <span class="alert alert-danger"
              v-if="errors.has('phone')"
              v-text="errors.get('phone')"
        >
          </span>
      </div>
      <div class="modal-form-block mb-6">
        <label for="state">
          {{ trans.get('dealers.email_label') }}
        </label>
        <input type="text"
               name="email"
               id="email"
               :placeholder="this.trans.get('dealers.email_placeholder')"
               v-model="dealer.email"
               required
        >
        <span class="alert alert-danger"
              v-if="errors.has('email')"
              v-text="errors.get('email')"
        >
          </span>
      </div>

      <div class="w-full flex justify-end px-4">
        <label for="visible">
          {{ trans.get('dealers.visible') }}
        </label>
        <input type="checkbox"
               class="ml-2"
               name="visible"
               v-model="dealer.visible"
        >
      </div>

      <div class="modal-form-block mb-6">
        <button class="w-1/3 mx-auto btn is-aitems-700"
                :disabled="errors.any()"
        >
          {{ trans.get('dealers.add-btn') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>

import Errors from "../../utilities/Errors";
import countriesList from "../../utilities/countries-list";

import iosSwitch from "../tools/iosSwitch";

export default {

  components: {
    iosSwitch
  },

  data() {
    return {
      dealer: {
        company: '',
        address1: '',
        postcode: '',
        city: '',
        state: '',
        country: 'nocountry',
        phone: '',
        email: '',
        visible: true
      },
      errors: new Errors(),
      locale: this.trans.getLocale()
    }
  },

  computed: {
    countries() {
      return countriesList[this.locale]
    }
  },

  methods: {
    onSubmit() {

      if (this.dealer.country === 'nocountry') {
        this.$toastr.w(this.trans.get('dealers.country_warning'));
        return;
      }

      swal.fire({
        title: this.trans.get('dealers.swal_save_title'),
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.trans.get('dealers.swal_yes_btn'),
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post('/warranty/dealers', this.dealer)
            .then(() => {
              this.$toastr.s(this.trans.get('dealers.save-success'))
            })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>